(function () {
  "use strict";

  angular
    .module("trakeyeApp")
    .controller("ProjectTreeController", ProjectTreeController);

  ProjectTreeController.$inject = [
    "$scope",
    "$rootScope",
    "TrProject",
    "ParseLinks",
    "AlertService",
    "pagingParams",
    "paginationConstants",
    "TrProjectSearch",
    "TrRouteListByProjectId",
    "routeDetail",
    "Inventory",
    "TrRouteForMap",
    "RouteByID",
  ];

  function ProjectTreeController(
    $scope,
    $rootScope,
    TrProject,
    ParseLinks,
    AlertService,
    pagingParams,
    paginationConstants,
    TrProjectSearch,
    TrRouteListByProjectId,
    routeDetail,
    Inventory,
    TrRouteForMap,
    RouteByID
  ) {
    var vm = this;
    vm.assets = [];
    vm.gpAssets = [];
    var locations = {};
    vm.loadPage = loadPage;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    $scope.search = pagingParams.search;
    vm.transition = transition;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.filterSearch = filterSearch;
    $scope.tab = 1;
    $scope.isSet = function (tabNum) {
      return $scope.tab === tabNum;
    };
    vm.getRoutePath = getRoutePath;
    vm.getRingPath = getRingPath;
    $scope.setTab = function (newTab) {
      $scope.tab = newTab;
      if ($scope.tab == 1) {
        filterSearch();
      }
    };
    if ($scope.tab == 1) {
      filterSearch();
    }
    function filterSearch() {
      if (
        $scope.search != null &&
        $scope.search != "" &&
        !angular.isUndefined($scope.search)
      ) {
        var searchVal = $scope.search.replace(/[^\w\s]/g, "_");
        TrProjectSearch.query(
          {
            search: searchVal,
            page: pagingParams.page - 1,
            size: vm.itemsPerPage,
            sort: sort(),
          },
          onSuccess,
          onError
        );
        function onSuccess(data, headers) {
          vm.links = ParseLinks.parse(headers("link"));
          vm.totalItems = headers("X-Total-Count");
          vm.queryCount = vm.totalItems;
          vm.projects = [];
          data.forEach(function (value) {
            if (value.zone) {
              value.type = "MASTER";
            } else {
              value.type = "MINI";
            }
            vm.projects.push(value);
          });
          vm.page = pagingParams.page;
        }

        function onError(error) {
          AlertService.error(error.data.message);
        }
      } else {
        loadAll();
      }
    }
    function loadAll() {
      TrProject.query(
        {
          page: pagingParams.page - 1,
          size: vm.itemsPerPage,
          sort: sort(),
        },
        onSuccess,
        onError
      );
      function sort() {
        var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
        if (vm.predicate !== "id") {
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers("link"));
        vm.totalItems = headers("X-Total-Count");
        vm.queryCount = vm.totalItems;
        vm.projects = [];
        data.forEach(function (value) {
          if (value.zone) {
            value.type = "MASTER";
          } else {
            value.type = "MINI";
          }
          vm.projects.push(value);
        });
        vm.page = pagingParams.page;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function mapStyles() {
      var styles;
      return (styles = [
        {
          featureType: "poi",
          elementType: "labels.icon",
          stylers: [{ color: "#63666A" }],
        },
        { elementType: "labels.text.fill", stylers: [{ color: "#63666A" }] },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{ color: "#63666A" }],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "landscape", stylers: [{ color: "#efefef" }] },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
      ]);
    }
    function myOption(zoom, center) {
      var myOptions;
      return (myOptions = {
        zoom: zoom,
        center: center,
        scaleControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapStyles(),
      });
    }
    function initMap() {
      var center = {
        lat: $rootScope.DEFAULT_LATITUDE,
        lng: $rootScope.DEFAULT_LONGITUDE,
      };
      locations.map = new google.maps.Map(
        document.getElementById("map_view"),
        myOption(12, center)
      );
      mapHeigh();
    }

    function mapHeigh() {
      var screenHeight = screen.height;
      if (screenHeight < 900) {
        document.getElementById("map_view").style.height = "80vh";
      } else {
        document.getElementById("map_view").style.height = "85vh";
      }
    }

    function sort() {
      var result = [vm.predicate + "," + (vm.reverse ? "asc" : "desc")];
      if (vm.predicate !== "id") {
        // result.push('id');
      }
      return result;
    }
    function loadPage(page) {
      vm.page = page;

      vm.transition();
    }
    function transition() {
      var searchVal = "";
      if (
        $scope.search != null &&
        $scope.search != "" &&
        !angular.isUndefined($scope.search)
      ) {
        searchVal = $scope.search.replace(/[^\w\s]/g, "_");
      }
      $state.transitionTo($state.$current, {
        page: vm.page,
        sort: vm.predicate + "," + (vm.reverse ? "asc" : "desc"),
        search: searchVal,
      });
    }
    initMap();
    vm.routeResponse = [];
    vm.sectionResponse = [];
    vm.sectionTaskResponse = [];
    vm.terrainResponse = [];
    vm.rowResponse = [];
    vm.routeTaskResponse = [];
    vm.routePlanResponse = [];
    vm.toggle = [];
    vm.expand = function (data, str) {
      if (str == "project") {
        vm.projects.forEach(function (item) {
          item.project = false;
        });

        if (vm.routePlanResponse.length) {
          vm.routePlanResponse.forEach(function (item) {
            item.routeBundles = false;
          });
        }
        if (vm.routeResponse.length) {
          vm.routeResponse.forEach(function (item) {
            item.route = false;
          });
        }
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
        if (vm.sectionTaskResponse.length) {
          vm.sectionTaskResponse.forEach(function (item) {
            item.sectionTask = false;
          });
        }

        if (vm.routeTaskResponse.length) {
          vm.routeTaskResponse.forEach(function (item) {
            item.routeTask = false;
          });
        }
      }
      if (str == "route") {
        vm.routeResponse.forEach(function (item) {
          item.route = false;
        });
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
      }

      if (str == "routeBundles") {
        vm.routePlanResponse.forEach(function (item) {
          item.routeBundles = false;
        });

        if (vm.routeResponse.length) {
          vm.routeResponse.forEach(function (item) {
            item.route = false;
          });
        }
        if (vm.sectionResponse.length) {
          vm.sectionResponse.forEach(function (item) {
            item.section = false;
          });
        }
      }

      if (str == "section") {
        vm.sectionResponse.forEach(function (item) {
          item.section = false;
        });
      }
      var iD = data.id ? data.id : data.sectionId;
      if (vm.toggle.includes(iD)) {
        vm.toggle = vm.toggle.filter(function (num) {
          return num !== iD;
        });
      } else {
        switch (str) {
          case "project":
            vm.headers = null;
            TrRouteListByProjectId.routeBundleByProjectId(
              data.id,
              function (data) {
                vm.headers = [{ key: "name", display: "Route Name" }];
                vm.routePlanResponse = data;
              }
            );
            data.project = true;
            vm.toggle.push(data.id);
            break;
          case "routeBundles":
            vm.headers = null;
            TrRouteListByProjectId.routesByRouteBundleId(
              data.id,
              function (data) {
                vm.headers = [{ key: "name", display: "Route Name" }];
                vm.routeResponse = data;
              }
            );
            data.routeBundles = true;
            vm.toggle.push(data.id);
            break;

          case "route":
            vm.sectionheaders = null;
            routeDetail.getRoutesDetails(data.id, function (data) {
              vm.sectionheaders = [
                { key: "sectionName", display: "Section Name" },
                /* {  display: "Action" }, */
              ];
              vm.sectionResponse = data;
            });

            routeDetail.getTask(data.id, function (data) {
              vm.routeTaskheaders = [
                { key: "name", display: "Task Name" },
                /* {  display: "Action" }, */
              ];
              vm.routeTaskResponse = data;
            });

            TrRouteForMap.getTerrainByRoute(data.id, function (data) {
              vm.terrainsheaders = [{ key: "name", display: "Terrain Name" }];
              vm.terrainResponse = data;
            });

            TrRouteForMap.getRoWByRoute(data.id, function (data) {
              vm.rowsheaders = [{ key: "name", display: "Row Name" }];
              vm.rowResponse = data;
            });

            data.route = true;
            vm.toggle.push(data.id);
            break;
          case "section":
            vm.sectionTaskheaders = null;
            Inventory.taskBySection(data.sectionId, function (response) {
              vm.sectionTaskheaders = [
                {
                  key: "name",
                  display: "Task Name",
                } /* 
                                    { key: "userLogin", display: "Assigned To" } */,
              ];
              vm.sectionTaskResponse = response;
            });
            data.section = true;
            vm.toggle.push(data.sectionId);
            break;
          case "sectionTask":
            if (vm.sectionTaskResponse.length) {
              vm.sectionTaskResponse.forEach(function (item) {
                item.sectionTask = false;
              });
            }

            data.sectionTask = true;
            vm.toggle.push(data.id);
            break;
          case "routeTask":
            if (vm.routeTaskResponse.length) {
              vm.routeTaskResponse.forEach(function (item) {
                item.routeTask = false;
              });
            }
            data.routeTask = true;
            vm.toggle.push(data.id);
            break;

          default:
            console.log("default");
        }
      }
    };
    vm.ringList = [];
    var polylines = [];
    vm.ring = [];
    var ringPolyline = [];
    var spreadPolyline = [];
    var assetMarker = [];
    var openedInfoWindow = null;

    function getRoutePath(id) {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      clearMapElements();
      vm.assets = [];
      vm.gpAssets = [];
      vm.ringList = [];

      TrRouteListByProjectId.routesByRouteBundleId(id, function (response) {
        vm.ringList = response;

        if (vm.ringList.length) {
          var completedCalls = 0;

          vm.ringList.forEach(function (ring) {
            RouteByID.get(ring.id, function (routeResponse) {
              drawPolyline(routeResponse, polylines);

              loadAssets(ring.id, null, function () {
                completedCalls++;
                if (completedCalls === vm.ringList.length) {
                  setupFilterOptions();
                }
              });
            });
          });
        }
      });
    }

    function getRingPath(id) {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      clearMapElements();
      RouteByID.get(id, function (response) {
        vm.ring = response;
        drawPolyline(vm.ring, ringPolyline);
        loadAssets(id, null);
      });
    }

    function drawPolyline(assets, targetPolylineArray) {
      if (!assets.routePoints || assets.routePoints.length === 0) return;

      var groupedByPhase = {};
      assets.routePoints.forEach(function (point) {
        if (point.routePointType === "COORDINATE") {
          var phase = point.phase;
          var session = point.sessionNumber;

          if (!groupedByPhase[phase]) {
            groupedByPhase[phase] = {};
          }

          if (!groupedByPhase[phase][session]) {
            groupedByPhase[phase][session] = [];
          }

          groupedByPhase[phase][session].push({
            lat: point.latitude,
            lng: point.longitude,
            routePointNumberDouble: point.routePointNumberDouble,
          });
        }
      });

      var bounds = new google.maps.LatLngBounds();
      var phaseColors = {
        PLANNING: "#FD7A24",
        SURVEY: "#007bff",
      };

      Object.keys(groupedByPhase).forEach(function (phase) {
        var sessions = groupedByPhase[phase];
        Object.keys(sessions).forEach(function (sessionKey) {
          var path = sessions[sessionKey];
          path.sort(function (a, b) {
            return a.routePointNumberDouble - b.routePointNumberDouble;
          });
          var polyline = new google.maps.Polyline({
            path: path,
            strokeColor: phaseColors[phase],
            geodesic: true,
            strokeOpacity: 1.0,
            strokeWeight: 3,
            zIndex: 2,
          });
          polyline.setMap(locations.map);
          targetPolylineArray.push(polyline);
          path.forEach(function (pt) {
            bounds.extend(pt);
          });
        });
      });

      if (!bounds.isEmpty()) {
        locations.map.fitBounds(bounds);
      }
    }

    function clearAllPolylines() {
      if (polylines.length) {
        polylines.forEach(function (polyline) {
          polyline.setMap(null);
        });
        polylines = [];
      }
    }

    function clearRingPolylines() {
      if (ringPolyline.length) {
        ringPolyline.forEach(function (polyline) {
          polyline.setMap(null);
        });
        ringPolyline = [];
      }
    }

    function clearSpreadPolylines() {
      if (spreadPolyline.length) {
        spreadPolyline.forEach(function (polyline) {
          polyline.setMap(null);
        });
        spreadPolyline = [];
      }
    }

    function clearAssetMarkers() {
      if (assetMarker.length) {
        assetMarker.forEach(function (marker) {
          marker.setMap(null);
        });
        assetMarker = [];
      }
    }
    function clearMapElements() {
      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();
      vm.assets = [];
      vm.gpAssets = [];
    }

    function loadAssets(routeId, lastId, doneCallback) {
      routeDetail.getAssetsById(routeId, lastId, function (response) {
        vm.routeAsset = response.assets;

        if (vm.routeAsset.length >= 100) {
          vm.routeAsset.forEach(function (asset) {
            vm.assets.push(asset);
          });

          loadAssets(
            routeId,
            vm.routeAsset[vm.routeAsset.length - 1].id,
            doneCallback
          );
        } else {
          vm.routeAsset.forEach(function (asset) {
            vm.assets.push(asset);
          });

          vm.assets.forEach(function (asset) {
            drawAssetMarker(asset);

            if (asset.assetTypeLayout === "SPREAD") {
              var coordinates = asset.assetCoordinates.map(function (coord) {
                return {
                  lat: coord.latitude,
                  lng: coord.longitude,
                };
              });

              var spreadLine = new google.maps.Polyline({
                path: coordinates,
                geodesic: true,
                strokeColor: "#0000FF",
                strokeOpacity: 0.9,
                strokeWeight: 2,
                zIndex: 1,
              });

              spreadLine.setMap(locations.map);
              spreadPolyline.push(spreadLine);
            }
          });

          if (doneCallback) {
            doneCallback();
          }
        }
      });
    }

    function drawAssetMarker(asset) {
      var coordinates = asset.assetCoordinates.map(function (coord) {
        return { lat: coord.latitude, lng: coord.longitude };
      });

      if (asset.assetTypeLayout === "FIXED") {
        vm.gpAssets.push(asset);

        var marker;
        if (
          asset.assetTypeName === "GP" &&
          (asset.phase === "SURVEY" || asset.phase === "ROLLOUT")
        ) {
          marker = new google.maps.Marker({
            position: coordinates[0],
            map: locations.map,
            title: asset.name,
            icon: {
              url: "content/images/yellowGp.png",
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        } else {
          marker = new google.maps.Marker({
            position: coordinates[0],
            map: locations.map,
            title: asset.name,
            icon: {
              url: asset.assetTypeImagePath,
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        }

        assetMarker.push(marker);

        function updateMarkerLabelVisibility() {
          var currentZoom = locations.map.getZoom();
          if (currentZoom > 14) {
            marker.setLabel({
              color: "black",
              fontWeight: "bold",
              fontSize: "12px",
              text: asset.name,
            });
          } else {
            marker.setLabel(null);
          }
        }

        google.maps.event.addListener(
          locations.map,
          "zoom_changed",
          updateMarkerLabelVisibility
        );

        var infowindow = new google.maps.InfoWindow();

        var updateIconSize = function () {
          var zoom = locations.map.getZoom();

          var minZoom = 8;
          var maxZoom = 21;
          var minSize = 6;
          var maxSize = 60;

          var newSize =
            minSize +
            ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize);

          var icon = {
            url: marker.getIcon().url,
            scaledSize: new google.maps.Size(newSize, newSize),
            anchor: new google.maps.Point(newSize / 2, newSize),
          };

          marker.setIcon(icon);
        };

        updateIconSize();

        google.maps.event.addListener(
          locations.map,
          "zoom_changed",
          function () {
            updateIconSize();
          }
        );
      }
    }

    function setupFilterOptions() {
      vm.filterOptions = [];

      var phaseSet = new Set();
      var assetTypeSet = new Set();
      var completedCalls = 0;

      if (!vm.ringList.length) return;

      vm.ringList.forEach(function (ring) {
        RouteByID.get(ring.id, function (routeResponse) {
          if (routeResponse.routePoints && routeResponse.routePoints.length) {
            routeResponse.routePoints.forEach(function (point) {
              if (point.phase) {
                phaseSet.add(point.phase);
              }
            });
          }

          completedCalls++;
          if (completedCalls === vm.ringList.length) {
            Array.from(phaseSet).forEach(function (phase) {
              vm.filterOptions.push({
                name: phase,
                type: "Phase",
                selected: true,
              });
            });
            vm.assets.forEach(function (asset) {
              if (asset.assetTypeName) {
                assetTypeSet.add(asset.assetTypeName);
              }
            });

            Array.from(assetTypeSet).forEach(function (type) {
              vm.filterOptions.push({
                name: type,
                type: "AssetType",
                selected: true,
              });
            });
            vm.selectedFilters = angular.copy(vm.filterOptions);
          }
        });
      });
    }

    vm.applyUnifiedFilter = function () {
      var selectedPhases = vm.selectedFilters
        .filter(function (f) {
          return f.type === "Phase";
        })
        .map(function (f) {
          return f.name;
        });

      var selectedAssetTypes = vm.selectedFilters
        .filter(function (f) {
          return f.type === "AssetType";
        })
        .map(function (f) {
          return f.name;
        });

      clearAllPolylines();
      clearRingPolylines();
      clearAssetMarkers();
      clearSpreadPolylines();

      vm.ringList.forEach(function (ring) {
        RouteByID.get(ring.id, function (response) {
          var filteredPoints = response.routePoints.filter(function (p) {
            return selectedPhases.indexOf(p.phase) !== -1;
          });

          if (filteredPoints.length > 0) {
            response.routePoints = filteredPoints;
            drawPolyline(response, polylines);
          }
        });
      });

      vm.assets.forEach(function (asset) {
        if (selectedAssetTypes.indexOf(asset.assetTypeName) !== -1) {
          drawAssetMarker(asset);

          if (asset.assetTypeLayout === "SPREAD") {
            var coordinates = asset.assetCoordinates.map(function (coord) {
              return { lat: coord.latitude, lng: coord.longitude };
            });

            var spreadLine = new google.maps.Polyline({
              path: coordinates,
              geodesic: true,
              strokeColor: "#0000FF",
              strokeOpacity: 0.9,
              strokeWeight: 2,
              zIndex: 1,
            });

            spreadLine.setMap(locations.map);
            spreadPolyline.push(spreadLine);
          }
        }
      });
    };
  }
})();
